module.exports = __webpack_public_path__ + "img/video_placeholder.c9701eec.jpg";